// @flow

import React from 'react'
import upIcon from '../../Icons/icon-up.svg'
import downIcon from '../../Icons/icon-down.svg'
import neutralIcon from '../../Icons/icon-neutral.svg'
import Loading from '../../Icons/loading.gif'
import { Link } from 'react-router-dom'
import Row from 'michelangelo/dist/Components/Row'
import Column from 'michelangelo/dist/Components/Column'

type Props = {
  loading: boolean,
  mostLikedPost: number,
  newLikesPercent: number,
  newReactionsPercent: number,
  mostCommentedPost: number,
  newCommentsPercent: number,
  sinceText: string,
  likedId: number,
  commentedId: number,
  reactedId: number,
  mostReactedPost: number,
  reactionCounts: Array,
  accountDetails: Object
}

function SocialBlock ({
  loading,
  mostLikedPost,
  newLikesPercent,
  newReactionsPercent,
  mostCommentedPost,
  newCommentsPercent,
  sinceText,
  likedId,
  accountDetails,
  reactedId,
  mostReactedPost,
  commentedId
}: Props) {
  const emptyNewLikesPercent = newLikesPercent === null || newLikesPercent === undefined
  const emptyNewReactionPercent = newReactionsPercent === null || newReactionsPercent === undefined
  const emptyNewCommentsPercent = newCommentsPercent === null || newCommentsPercent === undefined

  const LoadingIndicator = () => (<div><img src={Loading} alt='Loading' /></div>)

  return (
    <div className='BlockItem' style={{ flexBasis: '40%' }}>
      <h4>Social</h4>
      {loading && <LoadingIndicator />}
      {!loading && (
        <Row>
          <Column classNames={['is-5 is-5-desktop']}>
            <div className='BlockHeaderWrapper'>
              { accountDetails.ui_version !== 'v1'
                ? (likedId !== '0'
                    ? <Link to={{ pathname: '/content', search: `?id=${likedId}` }}>
                      <h3 className='HeaderLink'> {mostLikedPost} </h3>
                    </Link>
                    : <h3> {mostReactedPost} </h3>)
                : null
              }
              { accountDetails.ui_version === 'v1'
                ? (reactedId !== '0'
                    ? <Link to={{ pathname: '/content', search: `?id=${reactedId}` }}>
                      <h3 className='HeaderLink'> {mostReactedPost} </h3>
                    </Link>
                    : <h3> {mostReactedPost} </h3>)
                : null
              }
              <h5 className='BlockSubHeader'> Most {accountDetails.ui_version === 'v1' ? 'Reacted' : 'Liked'} Post </h5>
            </div>
            { accountDetails.ui_version === 'v1'
              ? (
                  emptyNewReactionPercent || newReactionsPercent === 0
                    ? <p><img src={neutralIcon} alt='Neutral' /> {newReactionsPercent} New reaction(s) <br /> {sinceText}</p>
                    : newReactionsPercent > 0
                      ? <p><img src={upIcon} alt='Up' /> {newReactionsPercent} New reaction(s) <br /> {sinceText}</p>
                      : <p><img src={downIcon} alt='Down' /> {newReactionsPercent} New reaction(s) <br /> {sinceText}</p>
                )
              : (
                  emptyNewLikesPercent || newLikesPercent === 0
                    ? <p><img src={neutralIcon} alt='Neutral' /> {newLikesPercent} New like(s) <br /> {sinceText}</p>
                    : newLikesPercent > 0
                      ? <p><img src={upIcon} alt='Up' /> {newLikesPercent} New like(s) <br /> {sinceText}</p>
                      : <p><img src={downIcon} alt='Down' /> {newLikesPercent} New like(s) <br /> {sinceText}</p>
                )
            }
          </Column>
          <Column classNames={['is-1 is-1-desktop']}>
            <div className='divider' />
          </Column>
          <Column classNames={['is-6 is-6-desktop']}>
            <div className='BlockHeaderWrapper'>
              {commentedId !== '0'
                ? <Link to={{ pathname: '/content', search: `?id=${commentedId}` }}>
                  <h3 className='HeaderLink'> {mostCommentedPost} </h3>
                </Link>
                : <h3> {mostCommentedPost} </h3>
              }
              <h5 className='BlockSubHeader'> Most Commented Post </h5>
            </div>
            {emptyNewCommentsPercent || newCommentsPercent === 0
              ? <p><img src={neutralIcon} alt='Neutral' /> {newCommentsPercent} New comment(s) <br /> {sinceText}</p>
              : newCommentsPercent > 0
                ? <p><img src={upIcon} alt='Up' /> {newCommentsPercent} New comment(s) <br /> {sinceText}</p>
                : <p><img src={downIcon} alt='Down' /> {newCommentsPercent} New comment(s) <br /> {sinceText}</p>}
          </Column>
        </Row>
      )}
    </div>
  )
}

export default SocialBlock
